<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="20">
          <el-form :inline="true">
            <el-form-item>
              <el-button type="primary" @click="add">添加合作商</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table :data="records" border>
        <el-table-column label="合作商名称" prop="name"></el-table-column>
        <el-table-column label="合作商分佣" prop="commission_ratio"></el-table-column>
        <el-table-column label="合作开始日期" prop="start_date"></el-table-column>
        <el-table-column label="合作截止日期" prop="end_date"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">编辑</el-button>
            <el-button type="danger" @click="del">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog
      title="添加合作商"
      :visible.sync="formVisible"
      width="600px">
      <el-form ref="formData" :model="formData" label-width="100px">
        <el-form-item label="合作商名称">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="合作商佣金">
          <el-input v-model="formData.commission_ratio">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="合作开始日期">
          <el-date-picker v-model="formData.start_date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="合作截止日期">
          <el-date-picker v-model="formData.end_date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onSave">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'Roles',
  data () {
    return {
      records: [],
      formData: {
        name: '',
        commission_ratio: '',
        start_date: '',
        end_date: ''
      },
      props: {
        label: 'name',
        children: 'children'
      },
      permissions: [],
      rolePermissions: [],
      currentChecked: null,
      formVisible: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      request.get('partners').then(res => {
        this.records = res.data
      })
    },
    PermissionChange (_data, checked) {
      console.log(checked.checkedKeys)
      this.rolePermissions = checked.checkedKeys
    },
    toggleTree (val) {
      this.$refs.tree.setCheckedNodes(val ? this.permissions : [])
      this.rolePermissions = this.$refs.tree.getCheckedKeys()
    },
    ParentChange (data, checked) {
      if (checked.checkedKeys.length > 0) {
        // 取消之前选中的节点
        if (this.currentChecked) {
          this.$refs.tree.setChecked(this.currentChecked, false)
        }
        this.currentChecked = data.id
      } else {
        this.currentChecked = null
      }
    },
    add () {
      this.modalTit = '添加'
      this.formVisible = true
    },
    edit (row) {
      this.modalTit = '编辑'
      this.formData = row
      this.formVisible = true
    },
    onCancel () {
      console.log(this.$refs)
      this.$refs.formData.resetFields()
      this.formVisible = false
    },
    onSave () {
      const loading = this.$loading({
        lock: true,
        text: '数据加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.5)'
      })
      if (this.currentRow) {
        this.formData.parent_id = this.currentRow.id
      }
      if (this.formData.id) {
        request.put(`partners/${this.formData.id}`, this.formData).then(() => {
          loading.close()
          this.$refs.formData.resetFields()
          this.getList()
          this.formVisible = false
        })
      } else {
        request.post(`partners`, this.formData).then(() => {
          loading.close()
          this.$refs.formData.resetFields()
          this.getList()
          this.formVisible = false
        })
      }
    },
    del () {
      this.$confirm('确定删除此项吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
</style>
